
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal/home",
      function () {
        return require("private-next-pages/personal/home.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal/home"])
      });
    }
  